import { Users, Flag, Heart, Clock, MapPin } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../../components/Reveal";
import { Eyebrow, Button } from "../../components/Bits";
import { IMG } from "../../lib/content";
import { EVENT_DATE } from "./prideData";
import { RainbowBar, RainbowArc } from "./PrideParts";

const points = [
  { icon: Users, title: "Everyone welcome", body: "Whether you are LGBTQ+, an ally, a family or just love a celebration, the parade is for you. No ticket needed, simply turn up and join in." },
  { icon: Flag, title: "Bring your colour", body: "Flags, banners, glitter and your best outfit. Community groups, schools and businesses are all welcome to walk with us." },
  { icon: Heart, title: "What it stands for", body: "The parade is a visible, joyful statement of equality, diversity and belonging on the Cumbrian coast, and the beating heart of the day." },
];

export default function PrideParade() {
  return (
    <div>
      <section className="relative overflow-hidden bg-nead-ink text-white">
        <div className="absolute inset-0">
          <img src={IMG.pride} alt="" className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-nead-ink via-nead-ink/85 to-nead-ink/55" />
        </div>
        <RainbowArc className="-top-40 -right-32 h-[26rem] w-[26rem]" />
        <div className="relative container-x py-16 md:py-24">
          <Eyebrow className="text-nead-cyan">The march</Eyebrow>
          <h1 className="mt-4 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl">The Pride parade.</h1>
          <p className="mt-5 max-w-2xl text-white/75 text-lg leading-relaxed">
            The day begins with our colourful Pride parade through Whitehaven, winding down to the harbour where the festival kicks off. It is free, open to all, and the most joyful walk you will take all year.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-white/85">
            <span className="inline-flex items-center gap-2"><Clock className="h-4 w-4 text-nead-cyan" /> Start time announced soon</span>
            <span className="inline-flex items-center gap-2"><MapPin className="h-4 w-4 text-nead-cyan" /> Through Whitehaven to the harbour</span>
          </div>
        </div>
      </section>

      <RainbowBar />
      <section className="container-x py-16 md:py-24">
        <Stagger className="grid md:grid-cols-3 gap-6">
          {points.map((p) => (
            <StaggerItem key={p.title}>
              <div className="h-full rounded-[1.5rem] border border-black/[0.07] p-8">
                <div className="flex h-12 w-12 items-center justify-center rounded-full grad-pink-cyan"><p.icon className="h-6 w-6 text-white" strokeWidth={1.8} /></div>
                <h3 className="mt-6 font-display font-bold text-xl text-nead-navy">{p.title}</h3>
                <p className="mt-3 text-nead-navy/60 leading-relaxed">{p.body}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <section className="container-x pb-20 md:pb-28">
        <div className="rounded-[1.75rem] grad-pink-cyan text-white p-10 md:p-14 text-center">
          <Flag className="h-8 w-8 mx-auto mb-4" />
          <h2 className="font-display font-bold text-3xl sm:text-4xl tracking-tight">Walk with us on {EVENT_DATE.replace("Sunday ", "")}.</h2>
          <p className="mt-4 text-white/85 max-w-xl mx-auto">Want to bring a group, a float or a banner? Get in touch and we will help you take part.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button to="/contact" variant="light" testId="parade-contact">Get in touch</Button>
            <Button to="/pride/whats-on" variant="light" testId="parade-whatson">See what's on</Button>
          </div>
        </div>
      </section>
    </div>
  );
}
